export default function Call({ style }: { style?: React.CSSProperties }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M22 16.92v3a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3.09 6.18 2 2 0 0 1 5.09 4h3a2 2 0 0 1 2 1.72 12.73 12.73 0 0 0 .57 2.8 2 2 0 0 1-.45 2L8.09 11a16 16 0 0 0 6.91 6.91l1.46-1.46a2 2 0 0 1 2-.45 12.73 12.73 0 0 0 2.8.57A2 2 0 0 1 22 16.92z"
        fill="currentColor"
      />
    </svg>
  );
}
